export enum InvitePersonStatus {
  Success = "Godkjent",
  Failed = "Feilet",
  Warning = "Advarsel",
}
